import { subDays } from "date-fns";

import type { LinksCustomDates } from "../types";

export const DefaultCustomDates: LinksCustomDates = {
  startDay: subDays(new Date(), 30),
  endDay: new Date(),
};
